module.exports = __webpack_public_path__ + "img/wallet.cdb421c6.svg";